// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".filter-card{height:100%;left:0;position:fixed;top:0;width:100%;z-index:50;--tw-bg-opacity:1;background-color:#fff;background-color:rgba(255,255,255,var(--tw-bg-opacity,1));padding:2.5rem 1rem}@media (min-width:900px){.filter-card{background-color:transparent;left:auto;padding:1rem;position:absolute;position:relative;width:auto;width:100%}.filter-card .top-card{top:4rem}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
